module.exports = __webpack_public_path__ + "img/1.4f15725e.jpg";